import { neutral2, neutral5, neutral7, primary, white } from '../../colors';
import { textFieldFadeOut, textFieldFocusStyle } from '../../sharedStyles';
import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

const placeholder = (idsTokens = idsTokensDefault) => ({
  color: idsTokens.textField.default.color.placeholder,
  opacity: 1,
  fontFamily: getFontFamily(idsTokens),
  ...fontSmoothing,
});

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    '&.Mui-disabled': {
      pointerEvents: 'none',
      '& .MuiInputAdornment-positionEnd svg': {
        color: neutral5,
      },
    },
    '&.Mui-error': {
      '& div[aria-haspopup=listbox]': {
        //border: `2px solid ${utilityNegative} !important`,
        '&:not([class=*"inputSizeSmall"])': {
          height: 40,
          lineHeight: 1.4,
          paddingLeft: 6,
        },
      },
    },
  },
  input: {
    boxSizing: 'border-box',
    fontFamily: getFontFamily(idsTokens),
    ...fontSmoothing,
    ...textFieldFadeOut,
    '&:hover': {
      '& div': {
        borderColor: primary,
      },
    },
    '&:focus': textFieldFocusStyle,
    '&:required': {
      '&:focus': textFieldFocusStyle,
    },
    '&::-webkit-input-placeholder': placeholder(idsTokens),
    '&::-moz-placeholder': placeholder(idsTokens), // Firefox 19+
    '&::-ms-input-placeholder': placeholder(idsTokens), // Edge
    '&:disabled': {
      color: neutral7,
    },
    '&.MuiOutlinedInput-input.Mui-disabled': {
      WebkitTextFillColor: 'unset',
    },
  },
  inputAdornedStart: {
    '&.MuiInputBase-input': {
      paddingLeft: 31,
    },
  },
  inputAdornedEnd: {
    paddingRight: 48,
  },
  multiline: {
    padding: 0,
    '&.MuiInputBase-sizeSmall': {
      paddingTop: 0,
    },
  },
  inputMultiline: {
    height: 'auto',
    padding: '9px 11px',
    backgroundColor: white,
    '&.Mui-disabled': {
      backgroundColor: neutral2,
    },
  },
  fullWidth: {
    '& > input': {
      width: '100%',
    },
  },
  inputSizeSmall: {
    fontSize: idsTokens.typography.font.size.sm,
    '&.MuiInput-input': {
      height: 32,
    },
  },
  sizeSmall: {
    '& .MuiSelect-selectMenu': {
      height: '32px !important',
    },
    '&.Mui-error .MuiSelect-selectMenu': {
      lineHeight: '28px !important',
    },
  },
});
